<template>
  <div class="login-wrapper justify-content-center d-flex w-100 h-90">
    <!-- Right Section: Login Form -->
    <div class="col-xl-6 col-12 d-flex flex-column justify-content-center align-items-center card" style="background-color: rgb(34, 121, 179);">
      <div class="form-container x-panel-bodyWrap">
        <!-- Title -->
        <h3 class="mb-3 mt-3 d-block text-center" style="color:#2279B3;">Είσοδος στο Σύστημα</h3>
        
        <!-- TAXIS Button (conditionally rendered) -->
        <button 
          v-if="showTaxisButton" 
          type="button" 
          class="w-100 btn" 
          style="background-color: #6DB4E3; color:white;" 
          @click="loginWithTaxisNet">
          Είσοδος μέσω TAXIS
        </button>
        
        <!-- Login Form -->
        <form 
          class="row g-1 p-3 p-md-4 justify-content-center align-items-center login-form" 
          @submit.prevent="login" 
          method="POST" 
          v-show="showLoginForm"
        >
          <!-- Username Input -->
          <div class="col-8 mb-2">
            <div class="mb-2">
              <input 
                type="email" 
                class="form-control form-control-md login-email text-wrap" 
                placeholder="Όνομα χρήστη" 
                v-model="username" 
                style="white-space: normal;" 
              />
            </div>
          </div>
          
          <!-- Password Input -->
          <div class="col-8">
            <div class="mb-2 position-relative">
              <input 
                :type="showPassword ? 'text' : 'password'" 
                v-model="password" 
                class="form-control form-control-md login-password pr-5" 
                placeholder="Κωδικός πρόσβασης" 
                autocomplete="off" 
              />
              
              <!-- Eye Icon -->
              <span class="showPasswordIcon" @click="togglePassword">
                <i :class="showPassword ? 'icofont-eye-blocked' : 'icofont-eye-alt'"></i>
              </span>
            </div>
          </div>

          <!-- Login Button -->
          <div class="col-8 text-center mt-4">
            <button type="button" class="w-100 btn" style="background-color: #6DB4E3; color:white;" @click="login">
              Είσοδος
            </button>
          </div>
        </form>

        <!-- Error Message -->
        <div class="error-div" v-if="errorMessage">
          <p>{{ errorMessage }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

  
  
  <script>
  import { onMounted, onUnmounted } from 'vue';
  import { login as authLoginGsis } from '../services/auth.js';
  import apiClient from '@/services/api.js';
  import FingerprintJS from '@fingerprintjs/fingerprintjs';
  
  export default {
    name: 'LoginTaxis',
    data() {
      return {
        username: '',
        password: '',
        remember_me: 0,
        errorMessage: null,
        twoFactor: false,
        twoFactorCode: '',
        browserFingerprint: null,
        showPassword: false,
        showLoginForm: false,
        showTaxisButton: true,
      };
    },
    setup() {
      const handleKeyPressed = (event) => {
        if (event.key === 'Enter') {
          $('.btn-login').trigger('click');
        }
      };
  
      onMounted(() => {
        document.addEventListener('keyup', handleKeyPressed);
      });
  
      onUnmounted(() => {
        document.removeEventListener('keyup', handleKeyPressed);
      });
    },
    async mounted() {
      // Load the FingerprintJS agent
      const fp = await FingerprintJS.load();
  
      // Get the fingerprint data asynchronously
      const result = await fp.get();
      this.browserFingerprint = result.visitorId;  // Save the browser fingerprint
    },
    methods: {
      showForm() {
        this.showLoginForm = true;  // Show the login form
        this.showTaxisButton = false; // Hide the TAXIS button
      },
      goToResetPassword() {
        this.$router.push('/reset-password');
      },
      togglePassword() {
        this.showPassword = !this.showPassword; // Toggle between true and false
      },
      async loginWithTaxisNet() {
        window.location.href = "https://eomtissues.gov.gr/backend/taxisnet/login";
      },
      async send2faVerificationCode() {
        const response = await apiClient.post('/send-2fa-code', {
          username: this.username,
          password: this.password,
          b_id: this.browserFingerprint // Use the browser fingerprint here
        });
        return response.data.success;
      },
      async login() {
        this.errorMessage = null;
        if (this.username && this.password) {
          try {
            const response = await authLoginGsis(this.username, this.password, this.browserFingerprint);
            if (response.data?.success) {
              if (response.data.data['2fa'] && !this.twoFactor) {
                this.twoFactor = true;
                const codeSent = await this.send2faVerificationCode();
                if (!codeSent) {
                  this.errorMessage = "Failed to send 2FA code";
                }
              } else if (response.data?.data?.token?.plainTextToken) {
                localStorage.setItem('api_token', response.data?.data?.token?.plainTextToken);
                localStorage.setItem('current_user_id', response.data?.data.info.id);
                const redirectAfterLogin = JSON.parse(sessionStorage.getItem('redirectAfterLogin'));
                if (redirectAfterLogin && redirectAfterLogin.name != 'Login' && redirectAfterLogin.name != 'LoginTaxis') {
                  this.$router.push(redirectAfterLogin);
                  sessionStorage.removeItem('redirectAfterLogin'); // Clear the redirect data
                } else {
                  if (response.data?.data?.info?.usertype_id == '1') { 
                    this.$router.push('/dashboard-institute'); // Default post-login route
                  } else {
                    this.$router.push('/dashboard-hospital');
                  }
                }
              }
            } else {
              this.errorMessage = response.data.message;
            }
          } catch (e) {
            this.errorMessage = "Λάθος στοιχεία σύνδεσης";
          }
        }
      },
      async verifyCode() {
        try {
          const response = await apiClient.post('/validate-2fa-code', {
            username: this.username,
            password: this.password,
            remember_me: this.remember_me ? 1 : 0,
            code: this.twoFactorCode,
            b_id: this.browserFingerprint // Use the browser fingerprint here
          });
          if (response.data.success) {
            // Manually set the cookie
            const token = response.data.data.token;
            const prefix = response.data.data.prefix;
            const expires = new Date();
            expires.setTime(expires.getTime() + 7 * 24 * 60 * 60 * 1000); // 7 days expiration time
            
            // Setting the cookie
            document.cookie = `${prefix}=${token}; expires=${expires.toUTCString()}; path=/; secure`;
  
            setTimeout(this.login, 500);
          } else {
            this.errorMessage = response.data.message;
          }
        } catch (error) {
          this.errorMessage = "Verification failed";
        }
      },
      showPass() {
        const passField = document.getElementById('showPassword');
        passField.type = passField.type === 'password' ? 'text' : 'password';
      }
    }
  };
  </script>
  <style scoped>
  /* Prevent scrolling */
  html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    overflow: hidden; /* Disable scrolling */
  }
  
  /* Header */
  .header {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 15px 30px;
    background-color: #ffffff;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  /* Login Wrapper */
  .login-wrapper {
    background: rgb(34, 121, 179);    height: calc(100vh - 100px); /* Adjusted height to fit screen without scrolling */
  }
  
  /* Eye Icon */
  .showPasswordIcon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    color: #2279B3;
    font-size: 1.2rem;
  }
  
  /* Error Message */
  .error-div p {
    color: red;
    font-size: 14px;
    text-align: center;
  }
  
  /* Form Container */
  .x-panel-bodyWrap {
    background: #fff;
    border: 1px solid #d1d1d1;
    border-radius: 5px;
    padding: 55px;
    box-shadow: 5px 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  
  
  input[type="password"]::-ms-reveal, 
  input[type="password"]::-ms-clear {
    display: none; /* Hides the default eye icon for Microsoft Edge */
  }
  
  footer{
  background-color: transparent !important;
}
  </style>
  